import { select, selectAll, on, trigger, getAttribute } from 'modules/dom'
import { fetchData } from 'modules/utils'
import { map } from 'modules/utils'

const UPCOMING_BUTTON_SELECTOR = '.js-upcoming-webinar'
const FORM_SELECTOR = '.js-form'
const MESSAGE_SELECTOR = '.js-message'
const CLOSE_MODAL_SELECTOR = '.js-close-modal'
const PROCESSING_TEXT = 'Processing...'
const ERROR_TEXT = 'Error! Try Again'
const DELAY_TIME = 1000
const ZOOM_REGISTER_SELECTOR = '.js-register-zoom-meeting'

export default (el) => {
  const upcomingButtons = selectAll(UPCOMING_BUTTON_SELECTOR, el)
  const zoomRegisterEls = selectAll(ZOOM_REGISTER_SELECTOR, el)
  const formEl = select(FORM_SELECTOR, el)
  const messageEl = select(MESSAGE_SELECTOR, el)
  const closeModalButton = select(CLOSE_MODAL_SELECTOR, el)
  if (upcomingButtons.length > 0) {
    map(upcomingButton => {
      const originText = upcomingButton.innerHTML
      const postId = upcomingButton.getAttribute('post-id')
      const isWebinarJoined = upcomingButton.getAttribute('is-webinar-joined')
      const isUserDataMissed = upcomingButton.getAttribute('is-user-data-missed')
      const webinarKey = upcomingButton.getAttribute('webinar-key')
      const errorHandler = (message) => {
        console.error(message)
        upcomingButton.innerHTML = ERROR_TEXT
      }
      const resetButton = () => {
        // set button to default text
        setTimeout(() => {
          upcomingButton.innerHTML = originText
        }, DELAY_TIME)
      }
      const handleButtonClick = () => {
        upcomingButton.innerHTML = PROCESSING_TEXT
        const endpoint = `${wpVars['ajaxUrl']}?action=webinar_register_new_attendee&post_id=${postId}`
        fetchData(endpoint, 'text').then((data) => {
          if (data) {
            if (isWebinarJoined === 'true') {
              // open new tab
              if (typeof gtag !== 'undefined') {
                gtag('event', 'Join Meeting', {
                  'event_category': 'GoToWebinar registration page',
                  'event_label': 'Click: You are registered. Join Meeting'
                })
              }
              window.open(data, '_blank')
            } else {
              // reload
              if (typeof gtag !== 'undefined') {
                gtag('event', 'Register', {
                  'event_category': 'GoToWebinar registration page',
                  'event_label': 'Click: Register for this webinar'
                })
              }
              window.location.reload()
            }
          } else {
            // console.log error
            errorHandler('Unable to generate join url')
          }
          resetButton()
        }).catch((e) => {
          const registerLink = `https://attendee.gotowebinar.com/register/${webinarKey}`
          window.open(registerLink, '_blank')
          resetButton()
          errorHandler(e.message)
        })
      }
      if (isUserDataMissed !== 'true') {
        on('click', (e) => {
          e.preventDefault()
          handleButtonClick()
        }, upcomingButton)
      }
      if (formEl) {
        on('submit', (e) => {
          e.preventDefault()
          jQuery.ajax({
            url: wpVars['ajaxUrl'],
            method: 'POST',
            data: jQuery(formEl).serialize(),
            success: function (data) {
              trigger('click', closeModalButton)
              handleButtonClick()
            },
            error: function (error) {
              console.log(error)
              messageEl.innerHTML = error.responseText
            }
          })
        }, formEl)
      }
    }, upcomingButtons)
  }
  if (zoomRegisterEls.length > 0) {
    map(zoomRegisterEl => {
      on('click', e => {
        e.preventDefault()
        const zoomRegisterButtonEl = e.target
        const zoomMeetingId = getAttribute('data-zoom-meeting-id', zoomRegisterButtonEl)
        if (!zoomMeetingId) return
        jQuery.ajax({
          url: wpVars['ajaxUrl'],
          method: 'POST',
          data: {
            action: 'zoom_meeting_register',
            meetingId: zoomMeetingId
          },
          success: function (response) {
            window.location.reload(true)
          },
          error: function (error) {
            console.log(error)
            messageEl.innerHTML = error.responseText
          }
        })
      }, zoomRegisterEl)
    }, zoomRegisterEls)
  }
}
